
<v-line v-if="!getStyleEdition" :zIndex='2' :config="configLine"></v-line>
